import axios from "axios";

const multiSourceExceptionProfilingReportApi = {
  show: (cde, page, pageSize, search, sort, filter) =>
    axios.get(`/api/v1/multi_source_exception_profiling_report/${cde}`, {
      params: { page, per_page: pageSize, search, sort, filter },
    }),
  get_aggregated_view: cde =>
    axios.get(
      `/api/v1/multi_source_exception_profiling_report/${cde}/aggregated_data`
    ),
  get_unique_column_values: (cde, columnName) =>
    axios.get(
      `/api/v1/multi_source_exception_profiling_report/values/${columnName}?cde_name=${cde}`
    ),
};

export default multiSourceExceptionProfilingReportApi;
